import configService from '../../services/config/configService.js';

const setMarket = (market) => {
    configService.updateConfig({app: {market}});
};

const setUserGroup = (userGroup) => {
    configService.updateConfig({app: {userGroup}});
};

export const configAppSetters = {
    setMarket,
    setUserGroup,
};
